import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';//props传参检查库

import './statementModal.css'

const StatementModal = (props) => {

    const [isShow, setIsShow] = useState(true);

    useEffect(() => {
    }, []);

    return (
        <Modal
            visible={isShow}//控制弹框是否显示
            centered//垂直居中
            destroyOnClose={true}//关闭即销毁？
            closable={false}//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭	
            width='850px'//弹框宽度
            footer={false}
        >
            <div className='statementModal'>
                <div>
                    <div className='title'>WIL Digital Platform Data Privacy Statement</div>
                    <div className='subTitle'>Welcome to the Work-integrated Learning Digital! We value your privacy and are committed to protecting your personal information. Before you start using our platform, we kindly ask you to read and acknowledge our Data Privacy Statement.</div>
                </div>
                <div>
                    <div>1. Purpose of Data Collection:</div>
                    <div className='grayText'>We collect your personal information to provide you with a seamless and personalized experience within the WIL Digital Platform, such as the job placement process. This includes delivering tailored content, enhancing functionality, and improving our services.</div>
                </div>
                <div>
                    <div>2. Types of Personal Identifiable Information Collected:</div>
                    <div>The information we collect may include, but is not limited to:</div>
                    <ul className='grayText'>
                        <li>Student ID and Name</li>
                        <li>Email and Social Media address</li>
                        <li>Contact phone</li>
                        <li>Profile picture</li>
                        <li>and information in the CV Package when student uploads for a job application</li>
                    </ul>
                </div>
                <div>
                    <div>3. Data Usage and Protection:</div>
                    <div className='grayText'>We use your personal information solely for the purposes stated in this Data Privacy Statement. Your data will be stored encrypted, securely and treated with utmost confidentiality. We will never sell or share your personal information with any third party without your explicit consent, unless required by law.</div>
                </div>
                <div>
                    <div>4. Data Retention:</div>
                    <div className='grayText'>We will retain your personal information for as long as necessary to fulfill the purposes outlined in this statement, or as required by law, and then it will be deleted. You may request the deletion or modification of your information at any time by contacting us at email theiwil@xxxxx</div>
                </div>
                <div className='buttonBox'>
                    <Button className='confirmButton' onClick={() => props.onClose(true)}>Confirm to proceed</Button>
                </div>
                <div className='smallText grayText'>{'By clicking the "Confirm" button and proceed to use the WIL Digital Platform, you confirm that you have read, understood, and agree to the WIL Digital Platform Data Privacy Statement, and you consent to the processing of your personal information as described.'}</div>
                <div className='flexCenterBox smallText grayText'>WIL Digital Platform</div>
            </div>
        </Modal>
    )
}

StatementModal.propTypes = {
    onClose: PropTypes.func.isRequired,
}
export default StatementModal;